import { memo } from 'react';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import { RedesignModalShell } from 'root/src/client/v2/common/components/RedesignModalShell';
// Redesign of the legacy static `GiveawayTermsConditionModal` (legacy MUI tokens). Same User
// Agreement copy, restyled with the redesign card + tokens. No data, pure presentation.
export const RedesignGiveawayTermsModal = memo(() => (<RedesignModalShell className="sm:max-w-2xl">
		<div className="flex w-full flex-col items-center gap-3 text-center">
			<div className="flex h-12 w-12 items-center justify-center rounded-full border border-solid border-neon-cyan/30 bg-neon-cyan/10">
				<GavelOutlinedIcon sx={{ fontSize: 24 }} className="text-neon-cyan"/>
			</div>
			<h2 className="font-display text-xl font-bold text-foreground">User Agreement for the Giveaway Feature</h2>
		</div>

		<div className="mt-2 max-h-[60vh] w-full space-y-4 overflow-y-auto pr-1 text-sm text-muted-foreground">
			<p>
				By participating in DareDrop&apos;s Giveaway Feature, you (the &quot;User&quot;) agree to the following terms and
				conditions:
			</p>
			<ol className="list-decimal space-y-3 pl-5 marker:font-semibold marker:text-foreground">
				<li>
					<span className="font-semibold text-foreground">Authorization to Access Steam Account:</span> You expressly
					authorize DareDrop to access specific details from your Steam account for the sole purpose of the giveaway:
					your public profile name, the total number of games you own, and per-game details (game name, playtime in the
					past 2 weeks, and total playtime on record since Steam began tracking this in early 2009).
				</li>
				<li>
					<span className="font-semibold text-foreground">Usage of Data:</span> If you are drawn as a winner, only your
					Steam public profile name will be displayed on the public winner announcement page. No other accessed data will
					be publicly displayed. By participating, you consent to this use.
				</li>
				<li>
					<span className="font-semibold text-foreground">Data Security:</span> DareDrop is committed to ensuring the
					security and protection of the personal data we process. All data accessed will be handled in accordance with
					applicable data protection laws.
				</li>
				<li>
					<span className="font-semibold text-foreground">Limitation of Liability:</span> DareDrop shall not be held
					responsible for any errors, omissions, or inaccuracies in the information pulled from the Steam platform. Users
					agree to release DareDrop from any liability relating to the usage of the above-mentioned data.
				</li>
				<li>
					<span className="font-semibold text-foreground">Changes to this Agreement:</span> DareDrop reserves the right to
					modify these terms and conditions at any time. Users will be notified of any significant changes.
				</li>
				<li>
					<span className="font-semibold text-foreground">Acceptance of the Agreement:</span> By participating, you
					acknowledge that you have read, understood, and agree to be bound by this User Agreement. If you do not agree
					with these terms, please do not participate in the giveaway.
				</li>
			</ol>
		</div>
	</RedesignModalShell>));
